// @flow
import { connect } from 'react-redux'
import CopyAdToAudience from './CopyAdToAudience'
import * as copyOperations from '../redux/ducks/copyAdToAudience/reducers'
import * as editOperations from '../redux/ducks/adEditWrapper/reducers'
import type { Store } from '../redux/ducks'

function mapStateToProps(state: Store) {
  return state.copyAdToAudience
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onSelectedAudienceChange: (id, providers) => {
      dispatch(copyOperations.select(id))
      dispatch(editOperations.patch({ providers }))
    }
  }
}

const CopyAdToAudienceContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(CopyAdToAudience)

export default CopyAdToAudienceContainer
